import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

export default function BooleanWidget({ data }) {
  function parseValue(value) {
    if (!value || value === 0) {
      return { className: 'text-danger', icon: faTimes };
    }

    return { className: 'text-success', icon: faCheck };
  }

  return (
    <div className="container-fluid">
      <div className="row py-2 sticky-top font-weight-light text-text-light-gray bg-white">
        <div className="col-1" />
        <p className="col-6 mb-0">Signal</p>
        <p className="col-4 col-md-5 mb-0">Timestamp</p>
      </div>
      {Array.isArray(data)
        ? data.map(({ name, value, time }, i) => (
            <div
              className="row mb-1 align-items-center text-muted nine-tenth-text"
              key={`${name}_${i}`}
            >
              <div className="col-1">
                <FontAwesomeIcon {...parseValue(value)} />
              </div>
              <p className="col-6 break-word mb-0">{name}</p>
              <p className="col-4 col-md-5 mb-0">{time}</p>
            </div>
          ))
        : null}
    </div>
  );
}

BooleanWidget.propTypes = { data: PropTypes.arrayOf(PropTypes.object) };
BooleanWidget.defaultProps = { data: [] };
